<script>
import AppIcon from '@site/components/common/AppIcon.vue'
import { clientBrands } from '@site/data/homeContent'

export default {
  name: 'CaseSection',
  components: { AppIcon },
  data() {
    return { clientBrands }
  },
}
</script>

<template>
  <section class="section section--white" id="clients">
    <div class="container">
      <div class="section-head reveal">
        <span class="section-eyebrow">客户案例</span>
        <h2>他们都选择了航富通</h2>
        <p>专业的研发/售后团队，为他们的选择持续保驾护航</p>
      </div>

      <div class="logo-grid reveal">
        <div v-for="brand in clientBrands" :key="brand.name" class="logo-item">
          <span class="logo-text">{{ brand.name }}</span>
          <span class="logo-tag">{{ brand.tag }}</span>
        </div>
      </div>

      <p class="clients-note">
        <AppIcon name="shield" :size="16" />
        以上为部分合作品牌展示（Logo 为占位，后续替换为授权素材）
      </p>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.logo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 16px;
}

.clients-note {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 32px;
  color: $color-text-muted;
  font-size: 13px;

  svg { color: $color-text-light; }
}
</style>



// WEBPACK FOOTER //
// src/site/components/home/CaseSection.vue